import React, { useState } from "react";
import _ from "lodash";
import { deleteWorkflowService } from "../../services/workflow";
import { formatDateTime } from "../../utils";

const DeleteWorkflowForm = function ({ id, appointment, closeModal }) {
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState(null);

  // Deleting a workflow makes no call to PMS, so an active appointment would be
  // left orphaned on the clinician's calendar. The cancel flow strips the whole
  // appointment object off the workflow, so a cancelled appointment simply is
  // not here - presence of appointmentId means it is still active.
  const appointmentId = _.get(appointment, "appointmentId");
  const hasActiveAppointment = !_.isNil(appointmentId) && appointmentId !== "";

  const appointmentDateTime = formatDateTime(_.get(appointment, "startDateTime", ""));
  const practitionerName = `${_.get(appointment, "practitioner.firstName", "")} ${_.get(
    appointment,
    "practitioner.lastName",
    ""
  )}`.trim();

  const blockedMessage =
    "This workflow still has an appointment" +
    (appointmentDateTime ? ` on ${appointmentDateTime}` : "") +
    (practitionerName ? ` with ${practitionerName}` : "") +
    ". Cancel the appointment first, then delete the workflow.";

  const handleClickConfirm = async () => {
    setIsDeleting(true);
    setDeleteError(null);
    try {
      await deleteWorkflowService({ ids: [id] });
      closeModal();
    } catch (error) {
      setDeleteError(_.get(error, "response.data.error", "Failed to delete this workflow. Please try again."));
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <h2 className="is-size-7 menu-label">Delete this workflow?</h2>
      <p>{hasActiveAppointment ? blockedMessage : "Please confirm that you want to delete this workflow."}</p>
      <div className="field is-grouped is-grouped-right">
        <p className="control">
          <button
            className={`button is-danger is-small${isDeleting ? " is-loading disabled" : ""}`}
            onClick={handleClickConfirm}
            disabled={hasActiveAppointment || isDeleting}
          >
            Confirm Deletion
          </button>
        </p>
      </div>
      {deleteError && (
        <p className="help is-danger" role="alert">
          {deleteError}
        </p>
      )}
    </>
  );
};

export default DeleteWorkflowForm;
